import { __spreadArray } from "tslib";
import $ from 'cheerio';
import { elementMutatorFactory } from './element-mutator';
export var postProcessHtmlFactory = function () {
    return {
        elements: ['p', 'div', 'h1', 'h2', 'h3'],
        mutators: [
            elementMutatorFactory(function ($el) {
                var maxLineHeight = Math.max.apply(Math, __spreadArray([
                    $el.css('line-height')
                ], $el
                    .find('span,p,div,h1,h2,h3')
                    .map(function (_, el) { return $(el).css('line-height'); })
                    .get()).map(function (lineHeight) { return parseInt(lineHeight, 10); }));
                $el.css('line-height', maxLineHeight + "px");
            }),
        ],
    };
};
//# sourceMappingURL=post-process-html.js.map